export const getDisplayName = (Component) =>
  Component.displayName || Component.name;
